<script lang="ts">
	import { onMount } from 'svelte';
	import { getClient, query } from 'svelte-apollo';
	import AppContainer from '../../components/AppContainer.svelte';
	import LoadingOverlay from '../../components/LoadingOverlay.svelte';
	import DataTable from '../../components/Segments/Dashboards/DataTable.svelte';
	import { getMixSegmentsQuery, getSegmentsQuery } from '../../graphql/queries/segments';
	import { getSegmentsDashboardQuery } from '../../graphql/queries/segments';

	const client = getClient();
	const getSegmentsOp = query(client, { query: getSegmentsQuery });
	const getSegmentsDashboardOp = query(client, { query: getSegmentsDashboardQuery});
	const getMixSegmentsOp = query(client, { query: getMixSegmentsQuery });

	function refresh() {
		getSegmentsOp.refetch();
		getSegmentsDashboardOp.refetch();
		getMixSegmentsOp.refetch();
	}

	onMount(() => {
		refresh();
	});
</script>

<AppContainer fluid>	
	{#await $getSegmentsOp}
		<LoadingOverlay title="Loading segments..." spinner />
	{:then data}
		{#await $getMixSegmentsOp}
			<LoadingOverlay title="Loading mixed segments..." spinner />
		{:then mixdata}
			{#await $getSegmentsDashboardOp}
				<LoadingOverlay title="Loading segments dashboard..." spinner />
			{:then qdata} 
				
			<DataTable
			data={data.data.segments}
			qdata={qdata.data.segmentsDashboard}
			mixdata={mixdata.data.getMixSegments}
			on:dispatchRefresh={refresh}
			/>
			
			{:catch error}
				{error}
			{/await}
		{:catch error}
			{error}
		{/await}
	{:catch e}
		{e}
	{/await}
</AppContainer>
